import React from "react";
import ReportHeader from "./Report_header";

function ClientDocuments(props) {
  const api_token =
    (props.location && props.location.state && props.location.state.api_token) ||
    localStorage.getItem("api_token");

  return (
    <>
      <div className="container no-container">
        <ReportHeader
          title="Client Documents"
          showBack={true}
          onBack={() => props.history.goBack()}
          showLogout={true}
        />

        <div className="dashboard-card-holder row mt-4">
          <div className="image-report-2">
            <div
              className={"m-2"}
              onClick={() => {
                props.history.push({
                  pathname: "/policy-download",
                  state: { api_token },
                });
              }}
            >
              <img
                src={require("../assets/images/policy-download.svg")}
                alt=""
              />
              <h5>Policy Download</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClientDocuments;

